<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title( style='padding : 10px') {{ title }}
          DaftarPeriksa()
</template>

<script>
import DaftarPeriksa from "@/components/DaftarPeriksa.vue";

export default {
  name: "Pengembalian",
  components: {
    DaftarPeriksa,
  },
  data () {
    return {
      title: 'Penyelesaian Pekerjaan',
    }
  },
  mounted () {
  },
  computed: {

  },
  methods: {
   
    },  
  watch :{
     
      }
};
</script>
